<template>
  <el-dialog
    :append-to-body="true"
    :title="$i18n.t(title)"
    :fullscreen="fullscreen"
    :visible="isOpen"
    @close="handleClose"
  >
    <slot></slot>
  </el-dialog>
</template>

<script>
export default {
  name: 'full-calendar-entity-selector',
  props: {
    isOpen: {
      type: Boolean,
      default: false,
    },
    fullscreen: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: 'Dialog Title',
    },
  },
  methods: {
    handleClose() {
      this.$emit('entity-selector-closed')
    },
  },
}
</script>

<style scoped></style>
